import { render, staticRenderFns } from "./Professors.vue?vue&type=template&id=795a0a4e&scoped=true&"
import script from "./Professors.vue?vue&type=script&lang=js&"
export * from "./Professors.vue?vue&type=script&lang=js&"
import style0 from "./Professors.vue?vue&type=style&index=0&id=795a0a4e&scoped=true&lang=css&"
import style1 from "./Professors.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795a0a4e",
  null
  
)

export default component.exports